import React, { useEffect, useRef, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Card, Button, Alert, Form, Row, Col, Container, Modal } from 'react-bootstrap';
import { firestore } from '../../firebase';

export default function AddProductToSale() {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showModal, setShowModal] = useState(false)
    const [codigo, setCodigo] = useState("");
    const [descripcion, setDescripcion] = useState("");
    const cantActual = useRef(0)
    const [cantVenta, setCantVenta] = useState(1);
    const [ventas, setVentas] = useState([]);
    const [venta, setVenta] = useState(0);
    const history = useHistory();

    function getProduct() {
        setLoading(true);
        setError("");

        const productoQuery = firestore.collection('productos').doc(id)
        productoQuery.onSnapshot(querySnapshot => {
            if (!querySnapshot.exists) {
                setError("El producto no existe");
            } else {
                const data = querySnapshot.data();
                setCodigo(data.codigo);
                setDescripcion(data.descripcion);
                cantActual.current = data.cantidad.actual;
                setLoading(false);
            }
        })       
    }

    function getSales() {
        setLoading(true);
        setError("");

        const ventasQuery = firestore.collection('ventas').where("confirmada", "==", false);
        ventasQuery.onSnapshot(querySnapshot => {
            const items = [];
            querySnapshot.forEach(doc => {
                items.push({
                    id: doc.id,
                    codigo: doc.data().codigo
                });
            });

            setVentas(items);
            setLoading(false);
        });
    }

    function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        setError("");

        if (!venta || !cantVenta || cantVenta < 1) {
            setError("Uno o más campos requeridos no llenados o incorrectos");
            setLoading(false);
            return null;            
        }

        if (cantVenta > cantActual.current) {
            setError(`La cantidad no puede ser mayor a la cantidad actual del producto (actualmente ${cantActual.current})`);
            setLoading(false);
            return null;             
        }

        const ventaRef = firestore.collection('ventas').doc(venta);

        firestore.runTransaction(async (t) => {
            const ventaDoc = await t.get(ventaRef);

            const newCantidades = ventaDoc.data().productos.cantidades;
            const newIds = ventaDoc.data().productos.ids;

            const index = newIds.indexOf(id);

            if (index !== -1) {
                newCantidades[index] = newCantidades[index] + Number(cantVenta);
            } else {
                newCantidades.push(Number(cantVenta));
                newIds.push(id);
            }
            await t.update(ventaRef, {'productos.cantidades': newCantidades, 'productos.ids': newIds});
        }).then(() => {
            setShowModal(true);
            setLoading(false);
        }).catch(err => {
            setError('Ocurrió un error inesperado, vuélvalo a intentar más tarde');
            setLoading(false);   
        })
    }

    function handleClose() {
        setShowModal(false);
        history.push(`/products/view_${id}`);
    }

    useEffect(() => {
        getProduct();
        getSales();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <Container 
        className="d-flex align-items-center justify-content-center"
        >
            <div className="w-100" style = {{ maxWidth: "500px"}}>
                <h2 className="text-center mt-3 mb-4">Agregar Producto a Venta</h2>
                <strong className="text-center mb-3">Código: </strong> {codigo} {' '}
                <strong className="text-center mb-3">Descripción: </strong> {descripcion}
                <Modal show={showModal} onHide={handleClose}>
                    <Modal.Header>
                        <Modal.Title>Éxito</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Se agregó el producto a la venta exitosamente.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleClose}>
                            Regresar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Card>
                    <Card.Body>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="product-sale-select-ventas">
                                    <Form.Control
                                    as="select" custom
                                    value={venta}
                                    onChange={e => setVenta(e.target.value)}
                                    disabled={loading}
                                    >
                                        <option value="">Escoja una venta</option>
                                        {ventas
                                        && ventas.map(v => {
                                            return (
                                                <option key={v.id} value={v.id}>{v.codigo}</option>
                                            )
                                        })}
                                    </Form.Control>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="product-sale-cantidad">
                                    <Form.Label>Cantidad</Form.Label>
                                    <Form.Control 
                                    type="number"
                                    value={cantVenta}
                                    onChange={e => setCantVenta(e.target.value)}
                                    disabled={loading}/>
                                </Form.Group>
                            </Row>
                            <Row className='m-2'>
                                <Col xs={12}>
                                    <Button className='mx-1' disabled={loading} type="submit">
                                        Confirmar
                                    </Button>
                                    <Button className='mx-1' disabled={loading} variant="danger"
                                    onClick={() => history.push(`/products/view_${id}`)}>
                                        Cancelar
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    )
}